import useFetchNotesAuditor from '@/api/notesAuditorInstance';
import type { ApiActorResponse } from '@/utils/assignment-process/types';
import type { FeaturesState, FeatureMap } from './features-types';
import featuresState from './features-state';
import { socket } from '@/socket';

export async function getFeatures() {
  const { data: response } = await useFetchNotesAuditor('/features', {
    custom: { silent: true },
  })
    .get()
    .json();

  const { data, success, errorData } = response.value ?? ({} as ApiActorResponse<FeaturesState>);

  if (success && data) {
    featuresState.features = data.features;
  } else {
    throw errorData;
  }
}

export function featuresSubscribe() {
  socket?.on('group-features-update', ({ features }: { features: FeatureMap }) => {
    featuresState.features = {
      ...featuresState.features,
      ...features,
    };
  });
}

export function featuresUnsubscribe() {
  socket?.off('group-features-update');
}
